var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "none",
    d: "M8.24386 17.4145C7.34783 17.833 6.55586 18.3853 5.87799 19.0632C5.59622 19.345 5.33402 19.6486 5.09261 19.9731C4.32205 21.0086 3.79523 22.2349 3.56912 23.5197C3.39126 24.5302 3.4003 25.5711 3.59223 26.5727C3.68418 27.0525 4.14889 27.3495 4.6336 27.288L11.7057 26.3905C12.4359 26.2978 13.0561 25.8116 13.3205 25.1247L15.3152 19.9409C20.2765 18.3001 27.6647 18.3001 32.6261 19.9409L34.6208 25.1247C34.8851 25.8116 35.5054 26.2978 36.2355 26.3905L43.3076 27.288C43.7923 27.3496 44.2571 27.0526 44.349 26.5727C44.5409 25.5711 44.55 24.5303 44.3721 23.5198C44.146 22.235 43.6192 21.0086 42.8486 19.9732C42.026 18.8679 40.9657 18.0071 39.6972 17.4146C35.7499 15.5709 30.9411 14.5964 23.9705 14.5964C17 14.5964 12.1912 15.5709 8.24386 17.4145Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneEnd);
export default __webpack_public_path__ + "static/media/phone-end.b75993d3b12341a8bc4eed8b4b9e9abc.svg";
export { ForwardRef as ReactComponent };